import { get, reduce } from 'lodash';
import { connect } from 'react-redux';

import CartUpsell from 'components/CartUpsell';
import * as actions from 'state/actions';
import { ADD_TO_CART_ORIGINS, COMPONENTS } from 'state/constants';
import CartSelector from 'state/selectors/cart';

// Generate a key based on the recommendation type, master product, list of colors and list of sizes
const getRecommendationKey = recommendation => {
  if (!recommendation) {
    return null;
  }

  const configKey = get(recommendation, ['config', 'type']);
  const masterProductKey = get(recommendation, ['recommendedMasterProduct', 'id']);
  const colorsKey = reduce(
    get(recommendation, ['recommendedColors']),
    (cacheKey, color) => `${cacheKey}--${color.handle}`,
    ''
  );
  const sizesKey = reduce(
    get(recommendation, ['recommendedSizes']),
    (cacheKey, size) => `${cacheKey}--${size}`,
    ''
  );

  return `${configKey}__${masterProductKey}__${colorsKey}__${sizesKey}`;
};

const mapStateToProps = state => {
  const recommendation = CartSelector.getCartRecommendation(state) || {};
  const key = getRecommendationKey(recommendation);

  return {
    ...recommendation,
    // Using key to force state "reset" and retrigger "componentDidMount" (https://reactjs.org/blog/2018/06/07/you-probably-dont-need-derived-state.html#recommendation-fully-uncontrolled-component-with-a-key)
    key,
  };
};

const mapDispatchToProps = dispatch => ({
  addToCart: id =>
    dispatch(actions.addLineItems({ [id]: 1 }, { origination: ADD_TO_CART_ORIGINS.UPSELL })),
  onMount: () => dispatch(actions.trackComponentMount(COMPONENTS.CART_UPSELL)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CartUpsell);
